import IGlobalTexts from "interfaces/IGlobalTexts";

const INIT_GLOBAL_TEXTS = "INIT_GLOBAL_TEXTS";

export const globalTextsActions = {
    init: (texts: IGlobalTexts) => ({
        type: INIT_GLOBAL_TEXTS,
        payload: texts
    })
};

const initialState: IGlobalTexts = {
    CookieConsentNotAcceptedText: "",
    FunctionalCookieConsentNotAcceptedText: "",
    MarketingCookieConsentNotAcceptedText: "",
    StatisticalCookieConsentNotAcceptedText: "",
    CookieConsentButtonText: ""
};

export default function globalTextsReducer(
    state = initialState,
    action: { type: string; payload?: IGlobalTexts }
): IGlobalTexts {
    switch (action.type) {
        case INIT_GLOBAL_TEXTS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
